
export default function SearchTermBox({ searchTerm, onRemove }) {
    return (
        <>
            {searchTerm && (
                <span class="badge rounded-pill bg-info text-white d-inline-flex align-items-center p-2">
                    {searchTerm}
                    <button type="button" class="btn btn-sm btn-info p-0 ms-2" style={{ width: "1.25rem", height: "1.25rem" }} onClick={onRemove}>
                        &times;
                    </button>
                </span>)}
        </>
    );
}